import React, { useReducer, useState, useEffect, useRef, useMemo } from 'react';
import Calendar from 'react-calendar';
import moment from 'moment';
import { Loading, Button } from 'carbon-components-react';
import { CaretDown16 as CaretDown } from '@carbon/icons-react';
import { Responsive as ResponsiveGridLayout } from "react-grid-layout";
import { withSize } from "react-sizeme";

import callPostApi from "../../requests/PostRequests";
import callGetApi from '../../requests/GetRequests';
import i18n from "../../i18n";
import * as Constants from '../../requests/URLConstants';
import { plannedData } from './plannedEventsMock';
import './HomeScreen.scss';
import * as workspaces from '../../config/WorkspaceConstants';
import SAP from "../../assets/image/SAP.svg";
import Automation from "../../assets/image/Automation.svg";
import Custom from "../../assets/image/Custom.svg";
import SalesForce from "../../assets/image/Salesforce.svg";
import ManageKPIs from './ManageKPIs';
import TimeFilter from '../ManageAutomationPage/Alerts/TimeFilter';
import Widget from "./Widget";
import { getNewTimeRange } from '../ManageAutomationPage/Alerts/TimeFilterUtil';
import * as DashboardConstants from '../Dashboards/DashboardConstants';
import HomeFilters from './HomeFilters';
import kpiConfig from "./KpiConfig";
import * as config from "../../config/Constants";
import "./Styles.scss";

const sizes = {
    'Extra large size (xl)': 'xl',
    'Default size': undefined,
    'Small size (sm)': 'sm',
};
const types = {
    'Default (default)': 'default',
    'Inline (inline)': 'inline',
};
const directions = {
    'Bottom (default)': 'bottom',
    'Top ': 'top',
};

function NewHomeScreen({ size: { width } }, props) {
    const title = i18n.t('homepage.title');
    const scheduledMaintenance = i18n.t('homepage.scheduledMaintenance');
    const homepageDesctitle = i18n.t('homepage.homepageDesctitle');
    const BizOpstitle = i18n.t('homepage.BizOpstitle');
    const whatsNew = i18n.t('homepage.whatsNew');
    const BizOpsSubTitle = i18n.t('homepage.BizOpsSubTitle');
    const contactPoc = i18n.t('homepage.contactPoc');
    const goToManageOperations = i18n.t('homepage.goToManageOperations');
    const immediateAction = i18n.t('homepage.immediateAction');
    const goToAnalytics = i18n.t('homepage.goToAnalytics');
    const homepageAnalyticsSubTitle = i18n.t('homepage.homepageAnalyticsSubTitle');

    const [value, onChange] = useState(new Date());
    const [workspace, setWorkspace] = React.useState("");
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [filteredEvents, setFilteredEvents] = useState([]);
    //const [MiscTooltip, setMiscTooltip] = useState("");
    const [isWorkspaceNotAvailable, setWorkspaceNotAvailable] = React.useState(null);
    const [userPrefLoading, setUserPrefLoading] = useState(true);
    const [showKpiTile, setShowKpiTile] = useState(false);
    const [timeFilterSelections, setTimeFilterSelections] = useState({});
    const [filterSelections, setFilterSelections] = useState(props.filterSelections);
    const [layouts, setLayouts] = useState({});
    const [preferencesChanged, setPreferencesChanged] = useState(false);
    const [items, setItems] = useState([]);

    const AutomationLabel = i18n.t('pageHeader.app.Automation');
    const SAPLabel = i18n.t('pageHeader.app.SAP');
    const SelectWorkspace = i18n.t('pageHeader.app.SelectWorkspace');
    const UserPreferenceslabel1 = i18n.t('pageHeader.app.UserPreferenceslabel1');
    const UserPreferenceslabel2 = i18n.t('pageHeader.app.UserPreferenceslabel2');
    const CustomLabel = i18n.t('pageHeader.app.Custom');
    const SalesforceLabel = i18n.t('pageHeader.app.Salesforce');


    let user = JSON.parse(localStorage.getItem('user'));
    const [alertFilterData, alertFilterDispatch] = useReducer(alertFilterDataReducer, { clients: [] });
    const [dashboardFilterSelectionsAutomation, setdashboardFilterSelectionsAutomation] = useState({ 'franchise': [], 'client': [] });
    const [dashboardFilterSelectionsSAP, setdashboardFilterSelectionsSAP] = useState({ 'franchise': [], 'client': [] });
    const [dashboardFilterSelectionsSalesforce, setdashboardFilterSelectionsSalesforce] = useState({ 'franchise': [], 'client': [] });
    const [disabledSelects, setDisabledSelects] = useState({ 'client-select': true });
    const [count, setCount] = useState(0);
    let layoutRef = useRef([]);

    let automationKpis = kpiConfig[workspaces.automation_ops].kpis;
    let sapKpis = kpiConfig[workspaces.sap_ops].kpis;
    let salesforceKpis = kpiConfig[workspaces.salesforce_ops].kpis;

    const setDefaultTimeFilter = () => {
        var selections = {};
        let endMoment = moment();
        let strEndMoment = endMoment.format();
        var formatedEndDate = endMoment.format('l');
        var formattedEndTime = endMoment.format('hh:mm');
        var endAMPM = endMoment.format('A');
        let startMoment = endMoment.subtract({ hours: 24 });
        let strStartMoment = startMoment.format();
        var formatedStartDate = startMoment.format('l');
        var formattedStartTime = startMoment.format('hh:mm');
        var startAMPM = startMoment.format('A');
        selections.startDateTime = strStartMoment
        selections.startDate = formatedStartDate;
        selections.startTime = formattedStartTime;
        selections.startAMPM = startAMPM;
        selections.endDateTime = strEndMoment;
        selections.endDate = formatedEndDate;
        selections.endTime = formattedEndTime;
        selections.endAMPM = endAMPM;
        selections.timeInterval = 0;
        selections.timeRangeType = "relative";  // relative , absolute
        selections.timeRange = "1D"; // can be 15m, 30m, 1H, 1D, 7D, 1M, 3M, 6M, 1Y, WTD, MTD, YTD
        setTimeFilterSelections(selections);
    }

    useEffect(() => {
        getCalendarEvents();
        getUserPreferences();
    }, []);

    useEffect(() => {
        let filteredEvents = filterEventsBySelectedDate(value);
        setFilteredEvents(filteredEvents);
    }, [value, calendarEvents, workspace]);

    useEffect(() => {
        if (workspace === workspaces.automation_ops) {
            callGetApi(Constants.GETALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
                .then(resp => {
                    if (resp.aggregations.franchises) {
                        let franchiseList = [];
                        resp.aggregations.franchises.buckets.forEach(element => {
                            let franchise = {};
                            franchise.name = element.key;
                            franchiseList.push(franchise);
                        });
                        alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                    }


                }).catch((error) => {
                    console.error('Error:', error);
                });
        }


        // Sap Filters
        if (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops) {
            callGetApi(Constants.GETSAPALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
                .then(resp => {
                    if (resp.aggregations.franchises) {
                        let franchiseList = [];
                        resp.aggregations.franchises.buckets.forEach(element => {
                            let franchise = {};
                            franchise.name = element.key;
                            franchiseList.push(franchise);
                        });
                        alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                    }

                }).catch((error) => {
                    console.error('Error:', error);
                });
        }
        if (workspace === workspaces.salesforce_ops) {
            callGetApi(Constants.GETSALESFORCEALERTSFILTERDATAURL, { 'Content-Type': 'application/json' })
                .then(resp => {
                    if (resp.aggregations.franchises) {
                        let franchiseList = [];
                        resp.aggregations.franchises.buckets.forEach(element => {
                            let franchise = {};
                            franchise.name = element.key;
                            franchiseList.push(franchise);
                        });
                        alertFilterDispatch({ type: "add_franchise", item: franchiseList });
                    }

                }).catch((error) => {
                    console.error('Error:', error);
                });
        }
    }, [workspace]);



    function alertFilterDataReducer(state, action) {
        switch (action.type) {
            case "add_franchise":
                return { ...state, franchises: action.item };
            case "add_clients":
                return { ...state, clients: action.item };
            default:
                return { ...state };
        }
    }


    function filterEventsBySelectedDate(date) {
        let events = [];
        let selectedDate = new Date(date);
        let eventDate;
        if (calendarEvents.length) {
            events = calendarEvents.filter(function (event) {
                selectedDate = moment(selectedDate).format("YYYY-MM-DD");
                eventDate = new Date(event.opened_at);
                eventDate = moment(eventDate).format("YYYY-MM-DD");
                return moment(selectedDate).isSame(moment(eventDate));
            });
        }

        // if (plannedData.length) {
        //     events = plannedData.filter(function (event) {
        //         selectedDate = moment(selectedDate).format("YYYY-MM-DD");
        //         eventDate = new Date(event.opened_at);
        //         eventDate = moment(eventDate).format("YYYY-MM-DD");
        //         return moment(selectedDate).isSame(moment(eventDate));
        //     });
        // }
        return events;
    };

    const getKpiLayouts = (layouts, workspace, source) => {
        if (layouts.length === 0) {
            if (source.home && source.home.homeKpisSAP && workspace === workspaces.sap_ops)
                setItems(['IncidentAnalysis', 'IncidentSummary', 'ResponseAndResolutionSLAMet', 'AlertVsIncidentTrend']);
            else if (source.home && source.home.homeKpisAutomation && workspace === workspaces.automation_ops)
                setItems(['IncidentAnalysis', 'IncidentSummary', 'ResponseAndResolutionSLAMet', 'SuccessRate']);
            else if (source.home && source.home.homeKpisSalesforce && workspace === workspaces.salesforce_ops)
                setItems(['LoginTrend', 'BatchJobsTrend', 'IntegrationTrend','AbandonedProcessesTrend']);
        }
        else {
            //console.log(layouts, "Layouts");
            let kpiItems = [], kpiItemsArr = [], resultArr = [];
            layouts && Array.isArray(layouts) && layouts.map((layoutItem) => {
                kpiItems.push(layoutItem['i']);
                layoutItem['w'] = 4.5;
                layoutItem['h'] = 7;
            })
            if (workspace === workspaces.automation_ops) {
                for (let i = 0; i < automationKpis.length; i++) {
                    for (let j = 0; j < kpiItems.length; j++) {
                        if (kpiItems[j] === automationKpis[i]) {
                            kpiItemsArr.push(kpiItems[j])
                        }
                    }
                }
            }
            else if (workspace === workspaces.sap_ops) {
                for (let i = 0; i < sapKpis.length; i++) {
                    for (let j = 0; j < kpiItems.length; j++) {
                        if (kpiItems[j] === sapKpis[i]) {
                            kpiItemsArr.push(kpiItems[j])
                        }
                    }
                }
            }
            else if (workspace === workspaces.salesforce_ops) {
                for (let i = 0; i < salesforceKpis.length; i++) {
                    for (let j = 0; j < kpiItems.length; j++) {
                        if (kpiItems[j] === salesforceKpis[i]) {
                            kpiItemsArr.push(kpiItems[j])
                        }
                    }
                }
            }
            for (let k = 0; k < layouts.length; k++) {
                for (let l = 0; l < kpiItemsArr.length; l++) {
                    if (kpiItemsArr[l] === layouts[k].i) {
                        resultArr.splice(k, 0, kpiItemsArr[l]);
                    }
                }
            }
            //console.log(resultArr, "resultArr");
            setLayouts({ layouts });
            setItems(resultArr);
        }
    }

    const getUserPreferences = () => {
        //Check except login and login callback i.e. for protected routes.
        let user = JSON.parse(localStorage.getItem('user'));
        setPreferencesChanged(false);
        if (user) {
            let body = { 'user': user.username };

            callPostApi(Constants.GETUSERPREFRENCESURL, {
                'Content-Type': 'application/json'
            }, body).then(respJson => {
                setUserPrefLoading(false);
                if (respJson && respJson && respJson._source) {
                    if (respJson._source.workspace) {
                        setWorkspace(respJson._source.workspace);
                        setWorkspaceNotAvailable(false);
                        if (respJson._source.workspace === workspaces.automation_ops || respJson._source.workspace === workspaces.sap_ops || respJson._source.workspace === workspaces.salesforce_ops) {
                            if (!respJson._source.home) {
                                if (respJson._source.workspace === workspaces.automation_ops) {
                                    setItems(['IncidentAnalysis', 'IncidentSummary', 'ResponseAndResolutionSLAMet', 'SuccessRate'])
                                }
                                else if (respJson._source.workspace === workspaces.sap_ops) {
                                    setItems(['IncidentAnalysis', 'IncidentSummary', 'ResponseAndResolutionSLAMet', 'AlertVsIncidentTrend']);
                                }
                                else if (respJson._source.workspace === workspaces.salesforce_ops) {
                                    setItems(['LoginTrend', 'BatchJobsTrend', 'IntegrationTrend','AbandonedProcessesTrend']);
                                }
                            }
                            else {
                                //let kpiLayouts = respJson._source.workspace === workspaces.automation_ops ? respJson._source.home && respJson._source.home.homeKpisAutomation : respJson._source.home && respJson._source.home.homeKpisSAP;
                                let kpiLayouts;
                                if (respJson._source.workspace === workspaces.automation_ops) {
                                    kpiLayouts = respJson._source.home && respJson._source.home.homeKpisAutomation
                                }
                                else if (respJson._source.workspace === workspaces.sap_ops) {
                                    kpiLayouts = respJson._source.home && respJson._source.home.homeKpisSAP
                                }
                                else if (respJson._source.workspace === workspaces.salesforce_ops) {
                                    kpiLayouts = respJson._source.home && respJson._source.home.homeKpisSalesforce
                                }
                                if (kpiLayouts === undefined) {
                                    if (respJson._source.workspace === workspaces.automation_ops) {
                                        setItems(['IncidentAnalysis', 'IncidentSummary', 'ResponseAndResolutionSLAMet', 'SuccessRate'])
                                    }
                                    else if (respJson._source.workspace === workspaces.sap_ops) {
                                        setItems(['IncidentAnalysis', 'IncidentSummary', 'ResponseAndResolutionSLAMet', 'AlertVsIncidentTrend']);
                                    }
                                    else if (respJson._source.workspace === workspaces.salesforce_ops) {
                                        setItems(['LoginTrend', 'BatchJobsTrend', 'IntegrationTrend','AbandonedProcessesTrend']);
                                    }
                                }
                                else {
                                    kpiLayouts && respJson._source.workspace && getKpiLayouts(kpiLayouts, respJson._source.workspace, respJson._source);
                                }

                            }
                        }
                    }
                    if (respJson._source.timeFilters) {
                        let timeFilter = respJson._source.timeFilters;

                        if (respJson._source.timeFilters.timeRangeType === "relative") {
                            timeFilter = getNewTimeRange(respJson._source.timeFilters.timeRange);
                            timeFilter.timeInterval = (respJson._source.timeFilters.timeInterval);
                        }
                        setTimeFilterSelections(timeFilter);
                    } else {
                        setDefaultTimeFilter();
                    }
                    if (respJson._source.dashboard && respJson._source.dashboard.dashboardFiltersAutomation) {
                        setdashboardFilterSelectionsAutomation(respJson._source.dashboard.dashboardFiltersAutomation);
                    } else setdashboardFilterSelectionsAutomation([]);
                    if (respJson._source.dashboard && respJson._source.dashboard.dashboardFiltersSAP) {
                        setdashboardFilterSelectionsSAP(respJson._source.dashboard.dashboardFiltersSAP);
                    } else setdashboardFilterSelectionsSAP([]);
                    if (respJson._source.dashboard && respJson._source.dashboard.dashboardFiltersSalesforce) {
                        setdashboardFilterSelectionsSalesforce(respJson._source.dashboard.dashboardFiltersSalesforce);
                    } else setdashboardFilterSelectionsSalesforce([]);

                    setPreferencesChanged(true);
                }
                else if (respJson === 500) {
                    setWorkspaceNotAvailable(true);
                }
            }).catch((error) => {
                console.error('Error:', error);
                setWorkspaceNotAvailable(true);
                setUserPrefLoading(false);
            });
        }
    }

    function getCalendarEvents(date) {
        callGetApi(Constants.CHANGEMANAGEMENT, {
            'Content-Type': 'application/json'
        }).then(res => {
            setCalendarEvents(res);
        }).catch(error => {
            //console.log(error);
        });
    };

    const updateUserPreferences = async (user, workspace, timeFilters, dashboardFiltersAutomation, dashboardFiltersSAP, dashboardFiltersSalesforce, kpiSap, kpiAutomation, kpiSalesforce, shouldUpdate) => {
        let body = { "user": user }; //, "timeFilters": timeFilters, "alertFilters": alertFilters, "pAlertFilters": pAlertFilters }
        let bodyJSON = {};
        bodyJSON.user = body.user;
        bodyJSON.home = {};
        if (workspace) {
            bodyJSON.workspace = workspace;
        }

        if (timeFilters) {
            bodyJSON.timeFilters = timeFilters;
        }

        let dashFiltersAutomation = {};
        let dashFiltersSAP = {};
        let dashFiltersSalesforce = {};

        let kpisAutomation = {};
        let kpisSAP = {};
        let kpisSalesforce = {};

        if (kpiAutomation && workspace === workspaces.automation_ops) {

            kpisAutomation =
            {
                "kpisAutomation": kpiAutomation

            };
            bodyJSON.home = kpisAutomation;
        }

        if (kpiSap && workspace === workspaces.sap_ops) {

            kpisSAP =
            {
                "kpisSap": kpiSap

            };
            bodyJSON.home = kpisSAP;
        }

        if (kpisSalesforce && workspace === workspaces.salesforce_ops) {

            kpisSalesforce =
            {
                "kpisSalesforce": kpiSalesforce

            };
            bodyJSON.home = kpisSalesforce;
        }

        if (dashboardFiltersAutomation && workspace === workspaces.automation_ops) {

            dashFiltersAutomation =
            {
                "dashboardFiltersAutomation": dashboardFiltersAutomation

            };
            bodyJSON.dashboard = dashFiltersAutomation;
        }


        if (dashboardFiltersSAP && (workspace === workspaces.sap_ops || workspace === workspaces.custom_ops)) {

            dashFiltersSAP =
            {
                "dashboardFiltersSAP": dashboardFiltersSAP
            };

            bodyJSON.dashboard = dashFiltersSAP;
        }

        if (dashboardFiltersSalesforce && workspace === workspaces.salesforce_ops) {

            dashFiltersSalesforce =
            {
                "dashboardFiltersSalesforce": dashboardFiltersSalesforce
            };

            bodyJSON.dashboard = dashFiltersSalesforce;
        }


        //console.log("BODYBODY", kpiSap);

        callPostApi(Constants.UPDATEUSERPREFRENCESURL, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                shouldUpdate !== false && getUserPreferences(body.user);
                //getUserPreferences(body.user);
            }).catch((error) => {
                console.error('Error:', error);
            });
    };

    const updateWorkspace = (_workspace) => {
        if (_workspace !== workspace) {
            let user = JSON.parse(localStorage.getItem('user'));
            updateUserPreferences(user.username, _workspace);
        }
    }

    const setWorkspaceOnFirstLogin = (workspaceSelected) => {
        setWorkspaceNotAvailable(false);
        updateWorkspace(workspaceSelected)
    }

    const handleKPITiles = () => {
        setShowKpiTile(!showKpiTile);
    }

    const handleShowKpi = (show) => {
        setShowKpiTile(!show);
    }

    const getStartTime = () => {
        if (timeFilterSelections.startDateTime) {
            let startM = moment(timeFilterSelections.startDateTime);
            let startMStr = startM.locale("en").format("lll");
            return startMStr;
        }
        else {
            return "";
        }
    };

    const getEndTime = () => {
        if (timeFilterSelections.endDateTime) {
            let endM = moment(timeFilterSelections.endDateTime);
            let endMStr = endM.locale("en").format("lll");
            return endMStr;
        }
        else {
            return "";
        }
    };

    const updateState = (state, stateValue) => {
        //console.log('got here');
        switch (state) {
            case 'dashboardFilterSelectionsAutomation':
                setdashboardFilterSelectionsAutomation(stateValue);
                updateUserPreferences(user.username, workspace, null, stateValue, null, null, null, null, null, true);
                break;
            case 'dashboardFilterSelectionsSAP':
                setdashboardFilterSelectionsSAP(stateValue);
                updateUserPreferences(user.username, workspace, null, null, stateValue, null, null, null, null, true);
                break;
            case 'dashboardFilterSelectionsSalesforce':
                setdashboardFilterSelectionsSalesforce(stateValue);
                updateUserPreferences(user.username, workspace, null, null, null, stateValue, null, null, null, true);
                break;
            case 'timeFilterSelections':
                setTimeFilterSelections(stateValue);
                updateUserPreferences(user.username, null, stateValue, null, null, null, null, null, null, true);
                break;
            case 'disabledSelects':
                setDisabledSelects(stateValue);
                break;
            case 'alertFilterData_clients':
                alertFilterDispatch({ type: "add_clients", item: stateValue });
                break;
            default:
        }
    };


    let countItem = 0;
    const onLayoutChange = (currentLayout, allLayouts) => {
        if (currentLayout.length === 0 && Object.keys(allLayouts).length > 0) {
            countItem = count + 1;
            setCount(countItem);
            delete (allLayouts.lg);
            let kpiItems = [];
            allLayouts && allLayouts.layouts && Array.isArray(allLayouts.layouts) && allLayouts.layouts.length > 0 && allLayouts.layouts.map((layoutItem, index) => {
                kpiItems.push(layoutItem['i']);
                layoutItem['w'] = 4.5;
                layoutItem['h'] = 7;
                layoutItem['x'] = (index * 5) % 10;
                layoutItem['y'] = (Math.floor(index / 2)) * 7;
            })
            if (currentLayout.length > 0) {
                if (workspace === workspaces.automation_ops) {
                    updateUserPreferences(user.username, workspace, null, null, null, null, null, currentLayout, null, false);
                }
                else if (workspace === workspaces.sap_ops) {
                    updateUserPreferences(user.username, workspace, null, null, null, null, currentLayout, null, null, false);
                }
                else if (workspace === workspaces.salesforce_ops) {
                    updateUserPreferences(user.username, workspace, null, null, null, null, null, null, currentLayout, false);
                }
            }
        }
        else if (currentLayout.length > 0 && Object.keys(allLayouts).length > 0) {
            if (count === 1) {
                // allLayouts && allLayouts.layouts && Array.isArray(allLayouts.layouts) && allLayouts.layouts.map((oldLayoutItem) => {
                //     currentLayout.map((newLayoutItem) => {
                //         if (oldLayoutItem['i'] === newLayoutItem['i']) {
                //             if (oldLayoutItem['x'] !== newLayoutItem['x'] && oldLayoutItem['y'] !== newLayoutItem['y']) {
                                if (workspace === workspaces.automation_ops) {
                                    updateUserPreferences(user.username, workspace, null, null, null, null, null, currentLayout, null, false);
                                }
                                else if (workspace === workspaces.sap_ops) {
                                    updateUserPreferences(user.username, workspace, null, null, null, null, currentLayout, null, null, false);
                                }
                                else if (workspace === workspaces.salesforce_ops) {
                                    updateUserPreferences(user.username, workspace, null, null, null, null, null, null, currentLayout, false);
                                }
                            //}
                        //}
                //     })
                // })
            }
            else {
                if (Object.keys(allLayouts).length > 0) {
                    if (allLayouts.hasOwnProperty('lg') && allLayouts.hasOwnProperty('layouts') && allLayouts.layouts.length < allLayouts.lg.length) {
                        currentLayout.map((layoutItem, index) => {
                            if (index === currentLayout.length - 1) {
                                layoutItem['w'] = 4.5;
                                layoutItem['h'] = 7;
                                layoutItem['x'] = (index * 5) % 10;
                                layoutItem['y'] = (Math.floor(index / 2)) * 7;
                            }
                        })
                        if (workspace === workspaces.automation_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, currentLayout, null, false);
                        }
                        else if (workspace === workspaces.sap_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, currentLayout, null, null, false);
                        }
                        else if (workspace === workspaces.salesforce_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, null, currentLayout, false);
                        }
                        setLayouts({ currentLayout });
                    }
                    else if (allLayouts.hasOwnProperty('md') && allLayouts.layouts && allLayouts.layouts.length < allLayouts.md.length) {
                        currentLayout.map((layoutItem, index) => {
                            if (index === currentLayout.length - 1) {
                                layoutItem['w'] = 4;
                                layoutItem['h'] = 7;
                                layoutItem['x'] = (index * 5) % 10;
                                layoutItem['y'] = (Math.floor(index / 2)) * 7;
                            }
                        })
                        if (workspace === workspaces.automation_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, currentLayout, null, false);
                        }
                        else if (workspace === workspaces.sap_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, currentLayout, null, null, false);
                        }
                        else if (workspace === workspaces.salesforce_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, null, currentLayout, false);
                        }
                        setLayouts({ currentLayout });
                    }
                    else if (allLayouts.hasOwnProperty('sm') && allLayouts.layouts && allLayouts.layouts.length < allLayouts.sm.length) {
                        currentLayout.map((layoutItem, index) => {
                            if (index === currentLayout.length - 1) {
                                layoutItem['w'] = 3.75;
                                layoutItem['h'] = 7;
                                layoutItem['x'] = 0;
                                layoutItem['y'] = index * 7;
                            }
                        })
                        if (workspace === workspaces.automation_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, currentLayout, null, false);
                        }
                        else if (workspace === workspaces.sap_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, currentLayout, null, null, false);
                        }
                        else if (workspace === workspaces.salesforce_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, null, currentLayout, false);
                        }
                        setLayouts({ currentLayout });
                    }
                    else if (allLayouts.hasOwnProperty('xs') && allLayouts.layouts && allLayouts.layouts.length < allLayouts.xs.length) {
                        currentLayout.map((layoutItem, index) => {
                            if (index === currentLayout.length - 1) {
                                layoutItem['w'] = 2.25;
                                layoutItem['h'] = 7;
                                layoutItem['x'] = 0;
                                layoutItem['y'] = index * 7;
                            }
                        })
                        if (workspace === workspaces.automation_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, currentLayout, null, false);
                        }
                        else if (workspace === workspaces.sap_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, currentLayout, null, null, false);
                        }
                        else if (workspace === workspaces.salesforce_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, null, currentLayout, false);
                        }
                        setLayouts({ currentLayout });
                    }
                    else {
                        if (allLayouts.hasOwnProperty('lg') && !allLayouts.hasOwnProperty('md') && !allLayouts.hasOwnProperty('sm') && !allLayouts.hasOwnProperty('xs')) {
                            currentLayout.map((layoutItem, index) => {
                                layoutItem['w'] = 4.5;
                                layoutItem['h'] = 7;
                            })
                        }
                        else if (allLayouts.hasOwnProperty('md')) {
                            currentLayout.map((layoutItem, index) => {
                                layoutItem['w'] = 4;
                                layoutItem['h'] = 7;
                            })
                        }
                        else if (allLayouts.hasOwnProperty('sm')) {
                            currentLayout.map((layoutItem, index) => {
                                layoutItem['w'] = 3.75;
                                layoutItem['h'] = 7;
                                layoutItem['x'] = 0;
                                layoutItem['y'] = index * 7;
                            })
                        }
                        else if (allLayouts.hasOwnProperty('xs')) {
                            currentLayout.map((layoutItem, index) => {
                                layoutItem['w'] = 2.25;
                                layoutItem['h'] = 7;
                                layoutItem['x'] = 0;
                                layoutItem['y'] = index * 7;
                            })
                        }
                        layoutRef.current = currentLayout;
                        if (workspace === workspaces.automation_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, currentLayout, null, false);
                        }
                        else if (workspace === workspaces.sap_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, currentLayout, null, null, false);
                        }
                        else if (workspace === workspaces.salesforce_ops) {
                            updateUserPreferences(user.username, workspace, null, null, null, null, null, null, currentLayout, false);
                        }
                        setLayouts({ currentLayout });
                    }
                }
            }
        }
        else {
            setLayouts({});
        }
    };
    const onRemoveItem = (itemId) => {
        setItems(items.filter(item => !itemId.includes(item)));
        let layoutsArr = [];
        if (itemId.length > 0) {
            if (Object.keys(layouts).length > 0 && ((layouts.hasOwnProperty('currentLayout') && layouts.currentLayout.length > 0) || (layouts.hasOwnProperty('layouts') && layouts.layouts.length > 0))) {
                let layoutResult = layouts.hasOwnProperty('currentLayout') && layouts.currentLayout.length > 0 ? layouts.currentLayout : layouts.layouts;
                if (itemId.length >= 1) {
                    layoutsArr = Array.isArray(layoutResult) && layoutResult.filter(item => !itemId.includes(item.i));
                }
                if (workspace === workspaces.automation_ops) {
                    updateUserPreferences(user.username, workspace, null, null, null, null, null, layoutsArr, null, false);
                } else if (workspace === workspaces.sap_ops) {
                    updateUserPreferences(user.username, workspace, null, null, null, null, layoutsArr, null, null, false);
                }
                else if (workspace === workspaces.salesforce_ops) {
                    updateUserPreferences(user.username, workspace, null, null, null, null, null, null, layoutsArr, false);
                }
            }
            else {
                if (Object.keys(layoutRef).length > 0) {
                    if (itemId.length >= 1) {
                        layoutsArr = Array.isArray(layoutRef) && layoutRef.filter(item => !itemId.includes(item.i));
                    }
                    if (workspace === workspaces.automation_ops) {
                        updateUserPreferences(user.username, workspace, null, null, null, null, null, layoutsArr, null, false);
                    } else if (workspace === workspaces.sap_ops) {
                        updateUserPreferences(user.username, workspace, null, null, null, null, layoutsArr, null, null, false);
                    }
                    else if (workspace === workspaces.salesforce_ops) {
                        updateUserPreferences(user.username, workspace, null, null, null, null, null, null, layoutsArr, false);
                    }
                }
            }

        }
    };
    const onAddItem = (itemId) => {
        setItems([...items, itemId]);
    };

    const getDataGrid = (item, index) => {
        let datagrid = {
            x: (index * 5) % 10,
            y: (Math.floor(index / 2)) * 7,
            w: 4.5,
            h: 7,
            i: item.toString()
        }
        if (Object.keys(layouts).length > 0 && layouts && layouts.layouts && layouts.layouts.length > 0) {
            if (layouts.layouts[index] !== undefined && layouts.layouts[index].i === item) {
                return layouts.layouts[index];
            }
            else {
                return {
                    x: (index * 5) % 10,
                    y: (Math.floor(index / 2)) * 7,
                    w: 4.5,
                    h: 7,
                    i: item.toString()
                }
            }
        }
        else {
            return datagrid;
        }
    }

    const renderTimeFilter = useMemo(()=>{
      return  <TimeFilter updateState={updateState} timeFilterSelections={timeFilterSelections}></TimeFilter>
    },[timeFilterSelections])

    return (
        <>
            {userPrefLoading === true ? <Loading small={true} /> :
                isWorkspaceNotAvailable === true ?
                    <div className="workspace-na">
                        <div className="carbon-display-Light-24">{SelectWorkspace}</div>
                        <div className="workspace-icons">
                            <div>
                                <img src={Automation} alt="" onClick={() => { setWorkspaceOnFirstLogin(workspaces.automation_ops) }} className="workspace-img" />
                                <div className="workspace-text carbon-display-Regular-24">{AutomationLabel}</div>
                            </div>
                            <div>
                                <img src={SAP} alt="" onClick={() => { setWorkspaceOnFirstLogin(workspaces.sap_ops) }} className="workspace-img" />
                                <div className="workspace-text carbon-display-Regular-24">{SAPLabel}</div>
                            </div>
                            <div>
                                <img src={Custom} alt="" onClick={() => { setWorkspaceOnFirstLogin(workspaces.custom_ops) }} className="workspace-img" />
                                <div className="workspace-text carbon-display-Regular-24">{CustomLabel}</div>
                            </div>
                            <div>
                                <img src={SalesForce} alt="" onClick={() => { setWorkspaceOnFirstLogin(workspaces.salesforce_ops) }} className="workspace-img" />
                                <div className="workspace-text carbon-display-Regular-24">{SalesforceLabel}</div>
                            </div>
                        </div>
                        <div className="workspace-desc carbon-display-Regular-12">{UserPreferenceslabel1} {"\n"} {UserPreferenceslabel2}</div>
                    </div> :
                    <div className="homepage-wrapper">
                        <div className='title-container'>
                            <div className="homepage-title">
                                {title}
                            </div>
                            <div className='right-content-time'>
                                <div className='time-filter'>
                                    <div className="margin-top-10px startTime carbon-display-Regular-14">{getStartTime()}</div>
                                    <div className="margin-top-10px margin-left-10px  margin-right-10px">{'-'}</div>
                                    <div className="margin-top-10px endTime carbon-display-Regular-14">{getEndTime()}</div>
                                    <div className="time-filter-button" >
                                       {renderTimeFilter}
                                    </div>
                                </div>
                                {config.URL.includes(config.unilever) === false &&
                                    <HomeFilters alertType={"reactive"} filterData={alertFilterData} filterSelectionsAutomation={dashboardFilterSelectionsAutomation} filterSelectionsSAP={dashboardFilterSelectionsSAP} filterSelectionsSalesforce={dashboardFilterSelectionsSalesforce}
                                        updateState={updateState} workspace={workspace} />}
                            </div>
                        </div>
                        <div className='kpi-border'>
                            <Button
                                className=""
                                renderIcon={CaretDown}
                                iconDescription="Icon Description"
                                hasIconOnly={false}
                                onClick={handleKPITiles}>
                                <div className="kpiBtn-title"> {DashboardConstants.ManageKPIs}</div>
                            </Button>
                        </div>
                        <div className="left-content bx--col-lg-13 bx--col-md-5" >
                            <ResponsiveGridLayout
                                className="layout"
                                layouts={layouts}
                                breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                                cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                                width={width}
                                rowHeight={60}
                                onLayoutChange={onLayoutChange}
                                isResizable={false}
                                margin={[4, 6]}
                                compactType='vertical'
                                maxRows={13}
                                allowOverlap={false}
                                containerPadding={{ lg: [20, 35], md: [10, 10], sm: [15, 15] }}
                            >
                                {items.map((item, index) => {
                                    return (
                                        <div
                                            key={item}
                                            index={index}
                                            className="widget"
                                            data-grid={getDataGrid(item, index)}
                                        >
                                            <Widget
                                                id={item}
                                                onRemoveItem={onRemoveItem}
                                                backgroundColor="#867ae9"
                                                dashboardFilterSelectionsAutomation={dashboardFilterSelectionsAutomation}
                                                dashboardFilterSelectionsSAP={dashboardFilterSelectionsSAP}
                                                dashboardFilterSelectionsSalesforce={dashboardFilterSelectionsSalesforce}
                                                timeFilterSelections={timeFilterSelections}
                                                workspace={workspace}
                                                preferencesChanged={preferencesChanged}
                                            />
                                        </div>
                                    )
                                })}
                            </ResponsiveGridLayout>
                        </div>
                        <div className='right-content bx--col-lg-3 bx--col-md-3' style={showKpiTile === true ? { borderLeft: 'none' } : { borderLeft: '1px solid rgb(0, 83, 154)' }}>
                            {showKpiTile &&
                                <ManageKPIs
                                    handleShowKpi={handleShowKpi}
                                    items={items}
                                    onRemoveItem={onRemoveItem}
                                    onAddItem={onAddItem}
                                    workspace={workspace}
                                    dashboardFilterSelectionsAutomation={dashboardFilterSelectionsAutomation}
                                    dashboardFilterSelectionsSAP={dashboardFilterSelectionsSAP}
                                    dashboardFilterSelectionsSalesforce={dashboardFilterSelectionsSalesforce}
                                    timeFilterSelections={timeFilterSelections}
                                />}
                            <div>
                                <div className="bx--col">
                                    <div className="calendar-title">{scheduledMaintenance}</div>
                                    <div className="calendar-tile">
                                        <Calendar
                                            onChange={onChange}
                                            value={value}
                                            formatShortWeekday={(locale, date) => {
                                                var d = new Date(date).toLocaleDateString('en-US', { weekday: 'short' })[0] // to get first letter of week day
                                                return `${d}`;
                                            }}
                                        />
                                    </div>
                                    <div className="planned-schedule">
                                        <div className="event-content">
                                            {filteredEvents.map((event, index) => (
                                                <div className="event carbon-display-Regular-16" key={index}>
                                                    {"Planned"}: {event.description}
                                                    <div className="timelines">{moment(event.opened_at).format('MMMM Do YYYY')}<br />{moment(event.opened_at).format('hh:mm A')} {event.closed_at ? `- ${moment(event.closed_at).format('hh:mm A')}` : ''} | GMT</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="knowledge-articles bx--col">
                                    <div className="">
                                        <div className="KPI-title" style={{ marginTop: '0px' }}>{whatsNew}</div>
                                        <div className="sub-title">{BizOpstitle}</div>
                                        <div className='article-content'>
                                            {homepageDesctitle}
                                        </div>
                                        <div className='article-content'>
                                            {BizOpsSubTitle}{'\n'}
                                            {contactPoc}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
            }
        </>
    )
}
export default withSize({ refreshMode: "debounce", refreshRate: 60 })(NewHomeScreen);